import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { templatesLicense } from '../../BaseURL';
import Templates from './Templates';
// Order matters:
//   tokens      — declares the variables Templates.css consumes
//   Templates   — the ported stylesheet, untouched
//   integration — overrides for hosting it inside this platform's chrome
import './tp-tokens.css';
import './Templates.css';
import './tp-integration.css';

// ============================================================================
//  Templates — licence gate
// ============================================================================
//
//  A WRAPPER, deliberately. Templates.js and its nine siblings are a verbatim
//  copy of the standalone Gigatt project's department; putting the subscription
//  check inside any of them would mean editing files whose whole point is that
//  they are unedited. This sits in front instead.
//
//  It is a courtesy, not the enforcement. Every /api/templates route is gated
//  server-side by requireTemplates against the central licence database — a
//  hidden screen stops nobody who can type a URL. What this avoids is a menu
//  entry that opens onto a wall of failed requests.

export default function TemplatesGate(props) {
  const [state, setState] = useState({ checked: false, allowed: false, reason: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(templatesLicense);
        if (!cancelled) {
          setState({ checked: true, allowed: !!data?.allowed, reason: data?.reason || null });
        }
      } catch (err) {
        // A 403 from the gate, or the endpoint missing on an older server, both
        // mean no access. Fail closed, matching the server.
        if (!cancelled) {
          setState({
            checked: true,
            allowed: false,
            reason: err.response?.data?.message || 'Templates is not enabled for this facility.',
          });
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Everything the department renders must sit inside .tp-theme — that div is
  // where the 30 CSS variables Templates.css depends on are declared.
  if (!state.checked) {
    return (
      <div className="tp-theme">
        <div className="tp-page"><div className="tp-empty">Loading…</div></div>
      </div>
    );
  }

  if (!state.allowed) {
    return (
      <div className="tp-theme">
        <div className="tp-page">
          <div className="tp-empty">
            <h3>Clinical Templates is not enabled</h3>
            <p>
              {state.reason
                || 'This department is a licensed add-on. Contact TotalCare support to enable it.'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tp-theme">
      <Templates {...props} />
    </div>
  );
}
